export default __webpack_public_path__ + "static/media/Group 2115.8392747e.png";